"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Folder = _interopRequireDefault(require("@mui/icons-material/Folder"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SNETFileUploadModule = _interopRequireDefault(require("./SNETFileUpload.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FileStats = props => {
  const {
    uploadSuccess,
    show,
    fileName,
    fileSize,
    error
  } = props;
  if (!show) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETFileUploadModule.default.imgUploaderContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETFileUploadModule.default.uploadDetails
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETFileUploadModule.default.uploadStatusContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      [_SNETFileUploadModule.default.errorField]: error,
      [_SNETFileUploadModule.default.successfullUpload]: uploadSuccess,
      [_SNETFileUploadModule.default.uploadStatusDefault]: !error && !uploadSuccess
    }, _SNETFileUploadModule.default.uploadStatusContainer)
  }, /*#__PURE__*/_react.default.createElement(_Folder.default, null), /*#__PURE__*/_react.default.createElement(_Typography.default, null, uploadSuccess ? "Files Uploaded Successfully" : "No/Wrong Files Uploaded"))), fileName && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: _SNETFileUploadModule.default.title
  }, "File Name:"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: _SNETFileUploadModule.default.value
  }, fileName)), Boolean(fileSize) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: _SNETFileUploadModule.default.title
  }, "Size:"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: _SNETFileUploadModule.default.value
  }, fileSize))));
};
FileStats.prototypes = {
  show: _propTypes.default.bool,
  uploadSuccess: _propTypes.default.func,
  fileName: _propTypes.default.func,
  fileSize: _propTypes.default.number
};
var _default = exports.default = FileStats;